export function groupOptions<T>(
  options: T[],
  labelAcessor: (option: T) => string,
) {
  const optionsMap: { [key: string]: { label: string; options: T[] } } = {};
  options.forEach((option) => {
    const label = labelAcessor(option);
    const entry = optionsMap[label];
    if (!entry) {
      optionsMap[label] = {
        label,
        options: [option],
      };
    } else {
      optionsMap[label].options.push(option);
    }
  });
  return Object.values(optionsMap);
}
